import { Injectable } from '@angular/core';
import { CADHistoryOperation } from '../types';

@Injectable({
  providedIn: 'root'
})
export class CADHistoryService {
  private operations: CADHistoryOperation[] = [];
  private currentIndex = -1;

  getOperations(): CADHistoryOperation[] {
    return [...this.operations];
  }

  getCurrentIndex(): number {
    return this.currentIndex;
  }

  canUndo(): boolean {
    return this.currentIndex >= 0;
  }

  canRedo(): boolean {
    return this.currentIndex < this.operations.length - 1;
  }

  record(operation: CADHistoryOperation): void {
    if (this.currentIndex < this.operations.length - 1) {
      this.operations = this.operations.slice(0, this.currentIndex + 1);
    }
    this.operations.push(operation);
    this.currentIndex = this.operations.length - 1;
  }

  undo(): number {
    if (!this.canUndo()) return this.currentIndex;
    this.currentIndex -= 1;
    return this.currentIndex;
  }

  redo(): number {
    if (!this.canRedo()) return this.currentIndex;
    this.currentIndex += 1;
    return this.currentIndex;
  }

  clear(): void {
    this.operations = [];
    this.currentIndex = -1;
  }
}
